import { render, staticRenderFns } from "./TheLoginForm.vue?vue&type=template&id=2c6a6cb0&scoped=true"
import script from "./TheLoginForm.vue?vue&type=script&lang=js"
export * from "./TheLoginForm.vue?vue&type=script&lang=js"
import style0 from "./TheLoginForm.vue?vue&type=style&index=0&id=2c6a6cb0&prod&lang=css"
import style1 from "./TheLoginForm.vue?vue&type=style&index=1&id=2c6a6cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a6cb0",
  null
  
)

export default component.exports